// extracted by mini-css-extract-plugin
export var cancelButton = "_p7-5";
export var content = "_p7-3";
export var createButton = "_p7-6";
export var drawerContainer = "_p7-0";
export var footer = "_p7-2";
export var header = "_p7-1";
export var orderFormColumn = "_p7-4";